// import { canvasWidth, canvasHeight } from '../../Constants/commonConstants';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import Hover from './hover';
import * as S from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

const options = {
  cMapUrl: 'cmaps/',
  standardFontDataUrl: 'standard_fonts/',
};

let timerId = null;
const cardTimerId = null;
let pageTimerID = null;

// TODO: can be optimized
const diffPageData = (index, annotationData) =>
  annotationData?.find((data) => data?.pageIndex === index + 1);

const convertIntoSvgPoints = (pointsArray) => {
  let result = '';
  pointsArray.forEach((item) => {
    const points = item?.map((point) => point + 0.1);
    result += points.join(',');
    result += ' ';
  });
  return result;
};

function ViewerDiv({
  url,
  totalPages,
  region,
  zoomLevel,
  totalRegionPages,
  setTotalRegionPages,
  annotationData,
  allCardData,
  setCard,
  visibleIndex,
  setVisibleIndex,
  setCardData,
  height,
}) {
  const [pagesToShow, setPagesToShow] = useState(
    totalRegionPages[region] > totalPages[region] ? totalPages[region] : totalRegionPages[region]
  );

  useEffect(() => {
    setPagesToShow(
      totalRegionPages[region] > totalPages[region] ? totalPages[region] : totalRegionPages[region]
    );
  }, [totalPages, totalRegionPages]);

  const getRectangleDetails = (pageIndex) => {
    const pageData = diffPageData(pageIndex, annotationData);

    if (!isEmpty(pageData) && pageData[region]) {
      return (pageData[region] ?? {})?.rectangles;
    }
    return [];
  };

  const scrollTo = (id, pageNo) => {
    // TODO: if (cardData.length < allCardData.length) setCardData(allCardData);
    setCardData(allCardData);
    const leftId = `${id}-annotation-leftRegion`;
    const rightId = `${id}-annotation-rightRegion`;
    const leftPageId = `page-leftRegion-${pageNo}`;
    const rightPageId = `page-rightRegion-${pageNo}`;
    const singlePageId = `page-singleRegion-${pageNo}`;
    let kindType;
    // TODO:
    allCardData?.map((item) => {
      if (item?.id === id) {
        kindType = item?.kind;
      }
    });
    // TODO: Optimize index
    setCard({
      id,
      index: allCardData.indexOf(allCardData?.find((item) => item?.id === id)),
      page_index: pageNo,
      kind: kindType,
    });
    const card = document.getElementById(id);
    let cardId;
    let pageId;
    if (region === 'leftRegion') {
      cardId = rightId;
      pageId = rightPageId;
    } else if (region === 'singleRegion') {
      pageId = singlePageId;
    } else {
      cardId = leftId;
      pageId = leftPageId;
    }
    // annotation card
    const section = document.getElementById(cardId);
    clearTimeout(timerId);
    clearTimeout(pageTimerID);

    timerId = setTimeout(() => {
      (card !== null ? card : document.getElementById(id))
        ?.scrollIntoViewPromise({ behavior: 'smooth' })
        ?.then(() => {
          if (!section) {
            const page = document.getElementById(pageId);

            if (page === null) {
              setTotalRegionPages((prevIndex) => {
                if (region === 'leftRegion') {
                  return {
                    ...prevIndex,
                    rightRegion: pageNo + 1,
                  };
                } else if (region === 'singleRegion') {
                  return {
                    ...prevIndex,
                    singleRegion: pageNo + 1,
                  };
                }
                return {
                  ...prevIndex,
                  leftRegion: pageNo + 1,
                };
              });

              pageTimerID = setTimeout(
                () =>
                  document.getElementById(pageId)?.scrollIntoViewPromise({
                    behavior: 'smooth',
                    block: 'center',
                  }),
                500
              );
            } else {
              page?.scrollIntoViewPromise({
                behavior: 'smooth',
                block: 'center',
              });
            }
          } else {
            section?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        });
    }, 1000);
  };

  useEffect(
    () => () => {
      clearTimeout(timerId);
      clearTimeout(cardTimerId);
      clearTimeout(pageTimerID);
    },
    []
  );

  useEffect(() => {
    console.info(zoomLevel);
  }, [zoomLevel]);

  // pagesToShow can resolve to undefined/NaN/negative/fractional when a region's
  // page count is missing (e.g. a tab whose document has no total_page). Guard it
  // so `new Array()` can never throw `RangeError: Invalid array length`.
  const safePagesToShow = Math.max(0, Math.floor(Number(pagesToShow)) || 0);

  return (
    <Document file={url} options={options}>
      {Array.from({ length: safePagesToShow }, (el, pageIndex) => {
        const rectangles = getRectangleDetails(pageIndex);
        const pageDetails = diffPageData(pageIndex, annotationData);
        // const pdfHeight = pageDetails
        //   ? Number(pageDetails[region]?.size?.height?.slice(0, -2))
        //   : 842;
        const pdfWidth = pageDetails ? Number(pageDetails[region]?.size?.width?.slice(0, -2)) : 595;
        const pdfHeight = height ? Number(height.slice(0, -2)) : 842;
        // const pdfWidth = 595

        return (
          <S.Section
            className={`page-${pageIndex + 1} page mb-16`}
            id={`page-${region}-${pageIndex + 1}`}
            onClick={() => {
              setVisibleIndex(null);
            }}
            key={pageIndex}
            width={`${(
              pdfWidth *
              ((region === 'leftRegion'
                ? zoomLevel.ORIGINAL_DOCUMENT
                : region === 'rightRegion'
                  ? zoomLevel.MODIFIED_DOCUMENT
                  : zoomLevel.SINGLE_DOCUMENT) +
                0.1)
            ).toFixed(0)}px`}
            height={`${(
              pdfHeight *
              ((region === 'leftRegion'
                ? zoomLevel.ORIGINAL_DOCUMENT
                : region === 'rightRegion'
                  ? zoomLevel.MODIFIED_DOCUMENT
                  : zoomLevel.SINGLE_DOCUMENT) +
                0.1)
            ).toFixed(0)}px`}
          >
            <Page
              key={`page_${pageIndex + 1}`}
              pageNumber={pageIndex + 1}
              scale={
                region === 'leftRegion'
                  ? +zoomLevel.ORIGINAL_DOCUMENT.toFixed(1)
                  : region === 'rightRegion'
                    ? +zoomLevel.MODIFIED_DOCUMENT.toFixed(1)
                    : +zoomLevel.SINGLE_DOCUMENT.toFixed(1)
              }
              // renderMode="none"
              renderAnnotationLayer={false}
              renderTextLayer={false}
              devicePixelRatio={1.6}
            />
            <div
              className='interaction-layer'
              style={{
                width: `${(
                  pdfWidth *
                  ((region === 'leftRegion'
                    ? zoomLevel.ORIGINAL_DOCUMENT
                    : region === 'rightRegion'
                      ? zoomLevel.MODIFIED_DOCUMENT
                      : zoomLevel.SINGLE_DOCUMENT) +
                    0.1)
                ).toFixed(0)}px`,
                height: `${(
                  pdfHeight *
                  ((region === 'leftRegion'
                    ? zoomLevel.ORIGINAL_DOCUMENT
                    : region === 'rightRegion'
                      ? zoomLevel.MODIFIED_DOCUMENT
                      : zoomLevel.SINGLE_DOCUMENT) +
                    0.1)
                ).toFixed(0)}px`,
              }}
            >
              {rectangles?.map((item) => {
                if (item?.type !== 'none') {
                  return (
                    <article key={`${pageIndex + 1 + item.id}-${region}`}>
                      <div
                        id={`${item.id}-${region}`}
                        role='button'
                        onClick={(e) => {
                          e.stopPropagation();
                          item.type !== 'unchanged' && setVisibleIndex(item?.id);
                        }}
                      >
                        {(item.points ?? [])?.map((point, index) => (
                          <span
                            className={
                              item.type === 'unchanged'
                                ? 'annotation unchanged-opacity'
                                : 'annotation'
                            }
                            role='button'
                            onClick={() =>
                              item.type !== 'unchanged' && scrollTo(item?.id, pageIndex + 1)
                            }
                            // couldn't find/log value of item.points
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            id={`${item?.id}-annotation-${region}`}
                            style={{
                              top:
                                point?.top *
                                ((region === 'leftRegion'
                                  ? zoomLevel.ORIGINAL_DOCUMENT
                                  : region === 'rightRegion'
                                    ? zoomLevel.MODIFIED_DOCUMENT
                                    : zoomLevel.SINGLE_DOCUMENT) +
                                  0.1),
                              left:
                                point?.left *
                                ((region === 'leftRegion'
                                  ? zoomLevel.ORIGINAL_DOCUMENT
                                  : region === 'rightRegion'
                                    ? zoomLevel.MODIFIED_DOCUMENT
                                    : zoomLevel.SINGLE_DOCUMENT) +
                                  0.1),
                              height:
                                (point?.bottom - point?.top) *
                                ((region === 'leftRegion'
                                  ? zoomLevel.ORIGINAL_DOCUMENT
                                  : region === 'rightRegion'
                                    ? zoomLevel.MODIFIED_DOCUMENT
                                    : zoomLevel.SINGLE_DOCUMENT) +
                                  0.1),
                              width:
                                (point?.right - point?.left) *
                                ((region === 'leftRegion'
                                  ? zoomLevel.ORIGINAL_DOCUMENT
                                  : region === 'rightRegion'
                                    ? zoomLevel.MODIFIED_DOCUMENT
                                    : zoomLevel.SINGLE_DOCUMENT) +
                                  0.1),
                              background:
                                item.type === 'unchanged'
                                  ? ''
                                  : region === 'leftRegion'
                                    ? 'hsla(0, 100%, 50%, 0.5)'
                                    : 'hsla(155, 97%, 38%, 0.8)',
                            }}
                          />
                        ))}
                      </div>

                      {visibleIndex === item?.id && (
                        <S.SvgContainer
                          className='svg-div'
                          width={`${(
                            pdfWidth *
                            ((region === 'leftRegion'
                              ? zoomLevel.ORIGINAL_DOCUMENT
                              : region === 'rightRegion'
                                ? zoomLevel.MODIFIED_DOCUMENT
                                : zoomLevel.SINGLE_DOCUMENT) +
                              0.1)
                          ).toFixed(0)}px`}
                          height={`${(
                            pdfHeight *
                            ((region === 'leftRegion'
                              ? zoomLevel.ORIGINAL_DOCUMENT
                              : region === 'rightRegion'
                                ? zoomLevel.MODIFIED_DOCUMENT
                                : zoomLevel.SINGLE_DOCUMENT) +
                              0.1)
                          ).toFixed(0)}px`}
                        >
                          <Hover
                            points={convertIntoSvgPoints(item?.regionOutlines)}
                            height={pdfHeight}
                            width={pdfWidth}
                          />
                        </S.SvgContainer>
                      )}
                    </article>
                  );
                }
              })}
            </div>
          </S.Section>
        );
      })}
    </Document>
  );
}

export default ViewerDiv;
